import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'

import uiConfig from './ui'

try {
  firebase.initializeApp(uiConfig.firebase)
} catch (err) {
  // already initialized
}

export default firebase
export const auth = firebase.auth()
export const db = firebase.firestore()
export const analytics = process.browser ? firebase.analytics() : null
